import { CartItemInterface, ProductInterface } from '@pylot-data/pylotschema'

export const identifyCartProductsCategories = (
    cartItems: CartItemInterface[] | [],
    urlPath: string | string[] | undefined,
    categoryNameParam: string | string[] | undefined
): CartItemInterface[] | [] => {
    return cartItems.map((cartItem) => {
        const { product } = cartItem

        return {
            ...cartItem,
            product: {
                ...product,
                category: {
                    name: getProductCategoryName(
                        product,
                        urlPath,
                        categoryNameParam
                    )
                }
            }
        }
    })
}

const getProductCategoryName = (
    product: ProductInterface,
    urlPath: string | string[] | undefined,
    categoryNameParam: string | string[] | undefined
): string => {
    if (categoryNameParam) return String(categoryNameParam).replaceAll('-', ' ')

    if (urlPath) {
        const path = Array.isArray(urlPath) ? urlPath.join('/') : urlPath
        return (
            product.categories?.find((category) => category?.url_path === path)
                ?.name || ''
        )
    }

    return ''
}
